import { useEffect, useState } from 'react';
import api from './api';

// Short-lived token for media/download/WebSocket URLs, so the login token never appears in a URL
let cached = null;
let pending = null;

export async function getMediaToken() {
    if (cached && cached.expiresAt - Date.now() > 10 * 60 * 1000) return cached.token;
    if (!pending) {
        pending = api.get('/auth/media-token').then((res) => {
            cached = { token: res.data.token, expiresAt: Date.now() + res.data.expires_in * 1000 };
            return cached.token;
        }).finally(() => { pending = null; });
    }
    return pending;
}

export function clearMediaToken() {
    cached = null;
}

export function useMediaToken(enabled = true) {
    const [token, setToken] = useState(cached ? cached.token : null);
    useEffect(() => {
        if (!enabled) return undefined;
        let active = true;
        const load = () => getMediaToken().then((t) => { if (active) setToken(t); }).catch(() => {});
        load();
        const timer = setInterval(load, 15 * 60 * 1000);
        return () => { active = false; clearInterval(timer); };
    }, [enabled]);
    return token;
}
